import {Component, HostListener} from '@angular/core';
import {ShareDataService} from '@signature-it/ngx-generic/services';

@Component({
    selector: 'page-scroll-to-top',
    templateUrl: './page-scroll-to-top.component.html',
    styleUrls: ['./page-scroll-to-top.component.scss'],
    standalone: false
})
export class PageScrollToTopComponentGeneric{
    scrolled:boolean = false;
    constructor(
        public shareDataService: ShareDataService
    ) {}

    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (document.body.scrollTop > 20 ||
            document.documentElement.scrollTop > 20) {
            this.scrolled = true;
        }
        else{
            this.scrolled = false;
        }
    }

    scrollToTop(){
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
}
